import { Navigate, Route, Routes } from "react-router-dom";

import Dashboard from "../pages/operator/dashboard/Dashboard";
import Lms from "../pages/operator/lms/Lms";
import Rules from "../pages/operator/rules/Rules";
import Scripts from "../pages/operator/scripts/Scripts";
import OperatorWorkSchedule from "../pages/operator/work-schedule/WorkSchedule";
import ProductDetails from "../widgets/operator/scripts/ProductDetailsContent/index";

import AddNewUser from "../pages/supervisor/add-new-user/AddNewUser";
import DashboardSupervisor from "../pages/supervisor/dashboard/DashboardSupervisor";
import OperatorDetails from "../pages/supervisor/operator-details/OperatorDetails";
import OperatorsSupervisor from "../pages/supervisor/operators/OperatorsSupervisor";
import ScriptsDetailsSupervisor from "../pages/supervisor/script-details/ScriptsDetailsSupervisor";
import ScriptsSupervisor from "../pages/supervisor/scripts/ScriptsSupervisor";
import WorkScheduleSupervisor from "../pages/supervisor/work-schedule/WorkScheduleSupervisor";
import CrmsSupervisor from "../pages/supervisor/crms/CrmsSupervisor";

import Login from "../pages/login/Login";
import AddScriptManagement from "../pages/management/add-script/AddScript";
import DashboardManegment from "../pages/management/dashboard/Dashboard";
import FreedPeople from "../pages/management/freed-people/FreedPeople";
import OperatorDetailsManegment from "../pages/management/operator-details/OperatorDetails";
import OperatorsManegment from "../pages/management/operators/Operators";
import ScriptsDetailsManegment from "../pages/management/script-details/ScriptDetails";
import ScriptsManegment from "../pages/management/scripts/Scripts";
import WorkScheduleManegment from "../pages/management/work-schedule/WorkSchedule";
import SupervisorWorkScheduleManagement from "../pages/management/supervisor-work-schedule/WorkSchedule";
import AddScriptSupervisor from "../pages/supervisor/add-script/AddScript";
import CrossDetailsPageSupervisor from "../pages/supervisor/cross-details/CrossDetailsPage";
import ScriptTemplateEditorSupervisor from "../pages/supervisor/script-templates/ScriptTemplateEditor";
import ScriptTemplateEditorManagement from "../pages/management/script-templates/ScriptTemplateEditor";
import ProtectedRoute from "./ProtectedRoute";
export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/operator/dashboard"
        element={
          <ProtectedRoute resource="operator.dashboard">
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/operator/lms"
        element={
          <ProtectedRoute resource="operator.lms">
            <Lms />
          </ProtectedRoute>
        }
      />
      <Route
        path="/operator/rules"
        element={
          <ProtectedRoute resource="operator.rules">
            <Rules />
          </ProtectedRoute>
        }
      />
      <Route
        path="/operator/scripts"
        element={
          <ProtectedRoute resource="operator.scripts">
            <Scripts />
          </ProtectedRoute>
        }
      />
      <Route
        path="/operator/scripts/:productId"
        element={
          <ProtectedRoute resource="operator.scripts">
            <ProductDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="/operator/work-schedule"
        element={
          <ProtectedRoute resource="operator.work_schedule">
            <OperatorWorkSchedule />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supervisor/dashboard/"
        element={
          <ProtectedRoute resource="supervisor.dashboard">
            <DashboardSupervisor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supervisor/operators"
        element={
          <ProtectedRoute resource="supervisor.operators">
            <OperatorsSupervisor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supervisor/add-new-user"
        element={
          <ProtectedRoute resource="supervisor.add_new_user">
            <AddNewUser />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supervisor/operator/:operatorId"
        element={
          <ProtectedRoute resource="supervisor.operator">
            <OperatorDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supervisor/scripts"
        element={
          <ProtectedRoute resource="supervisor.scripts">
            <ScriptsSupervisor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supervisor/scripts/:scriptId"
        element={
          <ProtectedRoute resource="supervisor.scripts">
            <ScriptsDetailsSupervisor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supervisor/cross-product/:scriptId"
        element={
          <ProtectedRoute resource="supervisor.scripts">
            <CrossDetailsPageSupervisor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supervisor/work-schedule"
        element={
          <ProtectedRoute resource="supervisor.work_schedule">
            <WorkScheduleSupervisor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supervisor/crms"
        element={
          <ProtectedRoute resource="supervisor.crm">
            <CrmsSupervisor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supervisor/add-script"
        element={
          <ProtectedRoute resource="supervisor.add_script">
            <AddScriptSupervisor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supervisor/script-templates/edit"
        element={
          <ProtectedRoute resource="supervisor.script_templates_edit">
            <ScriptTemplateEditorSupervisor />
          </ProtectedRoute>
        }
      />
      <Route
        path="/management/dashboard"
        element={
          <ProtectedRoute resource="management.dashboard">
            <DashboardManegment />
          </ProtectedRoute>
        }
      />
      <Route
        path="/management/crms"
        element={
          <ProtectedRoute resource="management.crm">
            <CrmsSupervisor variant="management" />
          </ProtectedRoute>
        }
      />
      <Route
        path="/management/operators"
        element={
          <ProtectedRoute resource="management.operators">
            <OperatorsManegment />
          </ProtectedRoute>
        }
      />
      <Route
        path="/management/add-new-user"
        element={
          <ProtectedRoute resource="management.add_new_user">
            <AddNewUser />
          </ProtectedRoute>
        }
      />
      <Route
        path="/management/operator/:operatorId"
        element={
          <ProtectedRoute resource="management.operator">
            <OperatorDetailsManegment />
          </ProtectedRoute>
        }
      />
      <Route path="/management/add-script" element={<AddScriptManagement />} />
      <Route
        path="/management/script-templates/edit"
        element={
          <ProtectedRoute resource="management.script_templates_edit">
            <ScriptTemplateEditorManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/management/scripts"
        element={
          <ProtectedRoute resource="management.scripts">
            <ScriptsManegment />
          </ProtectedRoute>
        }
      />
      <Route
        path="/management/scripts/:scriptId"
        element={
          <ProtectedRoute resource="management.scripts">
            <ScriptsDetailsManegment />
          </ProtectedRoute>
        }
      />
      <Route
        path="/management/work-schedule"
        element={
          <ProtectedRoute resource="management.work_schedule">
            <WorkScheduleManegment />
          </ProtectedRoute>
        }
      />
      <Route
        path="/management/supervisor-work-schedule"
        element={
          <ProtectedRoute resource="management.supervisor_work_schedule">
            <SupervisorWorkScheduleManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/management/freed-people"
        element={
          <ProtectedRoute resource="management.freed_people">
            <FreedPeople />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
